let googleMapsPromise: Promise<void> | null = null;

/**
 * Dynamically loads the Google Maps JavaScript API script and initializes required libraries.
 *
 * @param {string} apiKey - Your Google Maps API key.
 * @returns {Promise<void>} A promise that resolves once the API and selected libraries are fully loaded.
 *
 * @remarks
 * This function appends the Google Maps JavaScript API script to the document head,
 * and then uses `google.maps.importLibrary()` to load modular libraries such as
 * 'maps', 'marker', 'routes', etc.
 */
export function loadGoogleMapsAPI(apiKey: string): Promise<void> {
    if (googleMapsPromise) return googleMapsPromise;

    googleMapsPromise = new Promise<void>((resolve, reject) => {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&v=weekly`;
        script.async = true;
        script.defer = true;

        script.onload = async () => {
            try {
                await google.maps.importLibrary("maps");
                await google.maps.importLibrary("marker");
                resolve();
            } catch (err) {
                reject(err);
            }
        };

        script.onerror = () => reject(new Error("Google Maps API script failed to load"));
        document.head.appendChild(script);
    });

    return googleMapsPromise;
}